import { render, staticRenderFns } from "./QuestionFormBlock.vue?vue&type=template&id=3fe051f5&scoped=true&"
import script from "./QuestionFormBlock.vue?vue&type=script&lang=js&"
export * from "./QuestionFormBlock.vue?vue&type=script&lang=js&"
import style0 from "./QuestionFormBlock.vue?vue&type=style&index=0&id=3fe051f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe051f5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInput: require('/app/components/UI/UiInput.vue').default,UiInputWrapper: require('/app/components/UI/UiInputWrapper.vue').default,UiTextArea: require('/app/components/UI/UiTextArea.vue').default,UiButton: require('/app/components/UI/UiButton.vue').default})
